import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  FormField,
  Dropdown,
  Button,
  Icon
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'
import {
  Table
} from 'react-lib/frameworks/Table'

const CardEmployeeTimeAttendanceUX = (props: any) => {
    return(
      <div
        style={{padding: "10px"}}>
        <Form
          className="small"
          id="CardEmployeeSummaryWorkHourUX-Form-1">
          <FormGroup
            id="CardEmployeeSummaryWorkHourUX-FormGroup-2">
            <FormField
              id="CardEmployeeSummaryWorkHourUX-FormField-6"
              style={{display: props.readOnly?"none":""}}
              width={2}>
              <label
                id="CardEmployeeSummaryWorkHourUX-label-7">
                Department of affiliation
              </label>
              <Dropdown
                className="inline-label"
                fluid={true}
                id="CardEmployeeSummaryWorkHourUX-Dropdown-8"
                name="affiliate"
                onChange={props.onChangeFilter}
                options={props.divisionOptions}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.filter?.affiliate ?? ""}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardEmployeeSummaryWorkHourUX-FormField-9"
              style={{display: props.readOnly?"none":""}}
              width={2}>
              <label
                id="CardEmployeeSummaryWorkHourUX-label-10">
                Search employee
              </label>
              <div
                id="CardEmployeeTimeAttendanceUX-div-26"
                style={{width: "100%"}}>
                {props.employeeSearchBox}
              </div>
            </FormField>
            <FormField
              id="CardEmployeeTimeAttendanceUX-FormField-20"
              width={2}>
              <label
                id="CardEmployeeTimeAttendanceUX-label-28">
                Log type
              </label>
              <Dropdown
                clearable={true}
                fluid={true}
                id="CardEmployeeTimeAttendanceUX-Dropdown-27"
                name="type"
                onChange={props.onChangeFilter}
                options={props.logTypeOptions}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.filter?.type ?? ""}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardEmployeeTimeAttendanceUX-FormField-21"
              width={2}>
              <label
                id="CardEmployeeTimeAttendanceUX-label-33">
                Date
              </label>
              <div
                id="CardEmployeeTimeAttendanceUX-div-29"
                style={{width: "100%"}}>
                
                <DateTextBox
                  id="CardEmployeeTimeAttendanceUX-DateTextBox-31"
                  onChange={(value: any)=>props.onChangeFilter?.(null,{name: "clock_start_date", value})}
                  value={props.filter?.clock_start_date}>
                </DateTextBox>
              </div>
            </FormField>
            <FormField
              id="CardEmployeeTimeAttendanceUX-FormField-22"
              width={2}>
              <label
                id="CardEmployeeTimeAttendanceUX-label-34">
                {"\u00A0"}
              </label>
              <div
                id="CardEmployeeTimeAttendanceUX-div-30"
                style={{width: "100%"}}>
                
                <DateTextBox
                  id="CardEmployeeTimeAttendanceUX-DateTextBox-32"
                  onChange={(value: any)=>props.onChangeFilter?.(null,{name: "clock_end_date", value})}
                  value={props.filter?.clock_end_date}>
                </DateTextBox>
              </div>
            </FormField>
            <FormField
              id="CardEmployeeSummaryWorkHourUX-FormField-12"
              width={2}>
              <label
                id="CardEmployeeSummaryWorkHourUX-label-14">
                {"\u00A0"}
              </label>
              <div
                id="CardEmployeeSummaryWorkHourUX-div-13">
                {props.buttonSearch}
              </div>
            </FormField>
            <FormField
              id="CardEmployeeTimeAttendanceUX-FormField-23"
              style={{flex:1}}>
            </FormField>
            <FormField
              id="CardEmployeeTimeAttendanceUX-FormField-25"
              style={{display: props.readOnly?"none":""}}
              width={2}>
              <label
                id="CardEmployeeTimeAttendanceUX-label-38">
                {"\u00A0"}
              </label>
              <Button
                color="green"
                icon={true}
                id="CardEmployeeTimeAttendanceUX-Button-35"
                onClick={props.onClickAddManually}
                size="small">
                <Icon
                  id="CardEmployeeTimeAttendanceUX-Icon-36"
                  name="plus">
                </Icon>
                <label
                  id="CardEmployeeTimeAttendanceUX-label-37"
                  style={{marginLeft: "6px"}}>
                  Add manually
                </label>
              </Button>
            </FormField>
          </FormGroup>
        </Form>
        <div
          id="CardEmployeeSummaryWorkHourUX-div-15"
          style={{width: "100%"}}>
          {}
          <Table
            data={props.tableData}
            headers="Date, Employee ID, Employee name,Log type,Time,,Status"
            id="CardEmployeeTimeAttendanceUX-Table-39"
            keys="date,employee,employee_full_name,type,time,action,status_label"
            minRows={14}
            showPagination={false}
            sortable={false}
            style={{height: "calc(-18rem + 100vh)"}}
            widths="^120,^120,^150,^120,^100,^120,^100">
          </Table>
        </div>
        <div
          id="CardEmployeeTimeAttendanceUX-div-40"
          style={{marginTop: "1rem", display: "flex",justifyContent: "flex-end"}}>
          {props.pagination}
        </div>
      </div>
    )
}


export default CardEmployeeTimeAttendanceUX

export const screenPropsDefault = {"cannotPay":false,"cashAmountText":"14","citizenID":"31020000552","oweText":123,"patientNameAndHN":"HN: xxxxx นายทดสอบ","sumAmount":{"price":100,"reimbursable":42}}

/* Date Time : Wed Jul 16 2025 14:52:09 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": "semantic-ui-react",
      "id": 1,
      "name": "Form",
      "parent": 0,
      "props": {
        "className": {
          "type": "value",
          "value": "small"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-Form-1"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 2,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-FormGroup-2"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-FormField-6"
        },
        "style": {
          "type": "code",
          "value": "{display: props.readOnly?\"none\":\"\"}"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 7,
      "name": "label",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": "Department of affiliation"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-label-7"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "Dropdown",
      "parent": 6,
      "props": {
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "clearable": {
          "type": "code",
          "value": ""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-Dropdown-8"
        },
        "name": {
          "type": "value",
          "value": "affiliate"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "options": {
          "type": "code",
          "value": "props.divisionOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filter?.affiliate ?? \"\""
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-FormField-9"
        },
        "style": {
          "type": "code",
          "value": "{display: props.readOnly?\"none\":\"\"}"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": null,
      "id": 10,
      "name": "label",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": "Search employee"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-label-10"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 12,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-FormField-12"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 13,
      "name": "div",
      "parent": 12,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSearch"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-div-13"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "label",
      "parent": 12,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00A0\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-label-14"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-div-15"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 20,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-FormField-20"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 21,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-FormField-21"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 22,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-FormField-22"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 23,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-FormField-23"
        },
        "style": {
          "type": "code",
          "value": "{flex:1}"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 25,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-FormField-25"
        },
        "style": {
          "type": "code",
          "value": "{display: props.readOnly?\"none\":\"\"}"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": null,
      "id": 26,
      "name": "div",
      "parent": 9,
      "props": {
        "children": {
          "type": "code",
          "value": "props.employeeSearchBox"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-div-26"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 27,
      "name": "Dropdown",
      "parent": 20,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-Dropdown-27"
        },
        "name": {
          "type": "value",
          "value": "type"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "options": {
          "type": "code",
          "value": "props.logTypeOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filter?.type ?? \"\""
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": null,
      "id": 28,
      "name": "label",
      "parent": 20,
      "props": {
        "children": {
          "type": "value",
          "value": "Log type"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-label-28"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": null,
      "id": 29,
      "name": "div",
      "parent": 21,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-div-29"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": null,
      "id": 30,
      "name": "div",
      "parent": 22,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-div-30"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 31,
      "name": "DateTextBox",
      "parent": 29,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-DateTextBox-31"
        },
        "onChange": {
          "type": "code",
          "value": "(value: any)=>props.onChangeFilter?.(null,{name: \"clock_start_date\", value})"
        },
        "value": {
          "type": "code",
          "value": "props.filter?.clock_start_date"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 32,
      "name": "DateTextBox",
      "parent": 30,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-DateTextBox-32"
        },
        "onChange": {
          "type": "code",
          "value": "(value: any)=>props.onChangeFilter?.(null,{name: \"clock_end_date\", value})"
        },
        "value": {
          "type": "code",
          "value": "props.filter?.clock_end_date"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": null,
      "id": 33,
      "name": "label",
      "parent": 21,
      "props": {
        "children": {
          "type": "value",
          "value": "Date"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-label-33"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": null,
      "id": 34,
      "name": "label",
      "parent": 22,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00A0\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-label-34"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 35,
      "name": "Button",
      "parent": 25,
      "props": {
        "color": {
          "type": "value",
          "value": "green"
        },
        "icon": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-Button-35"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickAddManually"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 36,
      "name": "Icon",
      "parent": 35,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-Icon-36"
        },
        "name": {
          "type": "value",
          "value": "plus"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": null,
      "id": 37,
      "name": "label",
      "parent": 35,
      "props": {
        "children": {
          "type": "value",
          "value": "Add manually"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-label-37"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"6px\"}"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": null,
      "id": 38,
      "name": "label",
      "parent": 25,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00A0\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-label-38"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 39,
      "name": "Table",
      "parent": 15,
      "props": {
        "data": {
          "type": "code",
          "value": "props.tableData"
        },
        "headers": {
          "type": "value",
          "value": "Date, Employee ID, Employee name,Log type,Time,,Status"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-Table-39"
        },
        "keys": {
          "type": "value",
          "value": "date,employee,employee_full_name,type,time,action,status_label"
        },
        "minRows": {
          "type": "code",
          "value": "14"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "sortable": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"calc(-18rem + 100vh)\"}"
        },
        "widths": {
          "type": "value",
          "value": "^120,^120,^150,^120,^100,^120,^100"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": null,
      "id": 40,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.pagination"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-div-40"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"1rem\", display: \"flex\",justifyContent: \"flex-end\"}"
        }
      },
      "seq": 40,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardEmployeeTimeAttendanceUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "cannotPay": false,
    "cashAmountText": "14",
    "citizenID": "31020000552",
    "oweText": 123,
    "patientNameAndHN": "HN: xxxxx นายทดสอบ",
    "sumAmount": {
      "price": 100,
      "reimbursable": 42
    }
  },
  "width": 75
}

*********************************************************************************** */
